import * as React from 'react';

import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import glory_logo from 'assets/glory_logo.png';

import './Auth.css';
import { Stack } from '@mui/system';
import { IconButton, Typography } from '@mui/material';
import { useNavigate } from 'react-router';

interface AuthLayaoutProps {
    children: React.ReactNode;
    showBackButton?: boolean;
}

export default function AuthLayaout({ children, showBackButton }: AuthLayaoutProps) {
    const navigate = useNavigate();
    const handleBackClick = () => {
        navigate(-1);
    };
    return (
        <div className="Auth-body">
            <div className="Auth-container">
                <div className="Auth-container-logo">
                    {showBackButton && (
                        <Stack direction="row" alignItems="center" sx={{ position: 'relative', top: -140, left: -170 }}>
                            <IconButton onClick={handleBackClick}>
                                <KeyboardBackspaceIcon />
                            </IconButton>
                            <Typography>Back</Typography>
                        </Stack>
                    )}
                    <img src={glory_logo} className="Auth-logo" alt="logo" />
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <p className="Auth-logo-subTitle">Business Account</p>
                    </div>
                </div>
                {children}
            </div>
        </div>
    );
}
